module.exports = __webpack_public_path__ + "static/img/ico_handshack_money.839e023.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico_handshack_money.png
// module id = u4D7
// module chunks = 1